<template>
  <settings-modal
    class="card-order-decline-modal"
  >
    <template slot="heading">{{ heading }}</template>

    <template>
      <v-textarea
        v-model="form.reason"
        max-length="1024"
        class="t-decline-order-reason-field"
        label="Reason"
        hint="Required field"
        persistent-hint
        :error-messages="getValidationErrorMessage('reason')"
      />

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        class="t-decline-order"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || declineCardOrderApiRequest.loading"
        @click="declineCardOrder"
      >decline</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="closeModal"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Utils
  import { createCardOrderListRoute } from '@/utils/routing/Issuing'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CardOrderDeclineModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        declineCardOrderApiRequest: new ApiRequest(
          IssuingApi.declineCardOrder
        ),
        form: { reason: null },
        requiredFields: [
          'reason'
        ]
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      orderId () {
        return this.modal.data.orderId
      },
      heading () {
        return `Decline card order ${this.orderId}?`
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      declineCardOrder () {
        this.declineCardOrderApiRequest
          .execute(this.orderId, this.form.reason)
          .then(this.onCardOrderDeclineSuccess)
          .catch(this.onCardOrderDeclineError)
      },
      onCardOrderDeclineSuccess () {
        this.showModal({
          name: 'SuccessFlashModal',
          data: {
            redirectPath: createCardOrderListRoute(),
            message: 'Card order has been successfully declined.'
          }
        })
      },
      onCardOrderDeclineError () {
        this.showModal({
          name: 'ErrorFlashModal',
          data: {
            message: 'Card order has not been declined.'
          }
        })
      }
    }
  }
</script>
